// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class EntitlementCategoryProduct {
    constructor(name) {
        this.Array = [];
        this.startIndex = 0;
        this.endIndex = 0;
        this.availableWidth = 0;
        this.currentStep = 0;
        this.VisibleArray = [];
        this.IsHide = true; // is visible due to collapsed
        this.Name = name;
    }
    AddProduct(prod) {
        this.Array.push(prod);
        if (this.currentStep && this.currentStep < this.Array.length) {
            this.VisibleArray = this.Array.slice(this.startIndex, this.endIndex);
        }
        else {
            this.VisibleArray = this.Array;
            this.endIndex = this.VisibleArray.length;
        }
    }
    RemoveProduct(prod) {
        const index = this.Array.indexOf(prod);
        this.Array.splice(index, 1);
        if (this.currentStep && this.currentStep < this.Array.length) {
            this.VisibleArray = this.Array.slice(this.startIndex, this.endIndex);
        }
        else {
            this.startIndex = 0;
            this.VisibleArray = this.Array;
            this.endIndex = this.VisibleArray.length;
        }
    }
    SetAvaliableWidth(width) {
        this.availableWidth = width;
        this.currentStep = Math.trunc(width / EntitlementCategoryProduct.ONE_CARD_WIDTH);
        // magic math
        if (this.currentStep >= this.Array.length) {
            this.startIndex = 0;
        }
        this.endIndex = this.startIndex + this.currentStep;
        if (this.endIndex > this.Array.length) {
            this.endIndex = this.Array.length;
            this.startIndex = this.endIndex - this.currentStep;
            if (this.startIndex < 0) {
                this.startIndex = 0;
            }
        }
        if (this.currentStep < this.Array.length) {
            this.VisibleArray = this.Array.slice(this.startIndex, this.endIndex);
        }
        else {
            this.VisibleArray = this.Array;
        }
    }
    IsExists(prod) {
        const index = this.Array.indexOf(prod);
        return index !== -1;
    }
    IsEmpty(prod) {
        return this.Array.length === 0;
    }
    HasCategoryName() {
        return this.Name !== NO_NAME_CATEGORY;
    }
    LeftArrowClick() {
        this.startIndex -= this.currentStep;
        if (this.startIndex < 0) {
            this.startIndex = 0;
        }
        this.endIndex = this.startIndex + this.currentStep;
        this.VisibleArray = this.Array.slice(this.startIndex, this.endIndex);
    }
    RightArrowClick() {
        this.startIndex += this.currentStep;
        this.endIndex = this.startIndex + this.currentStep;
        this.VisibleArray = this.Array.slice(this.startIndex, this.endIndex);
    }
}
EntitlementCategoryProduct.ONE_CARD_WIDTH = 120;
export const NO_NAME_CATEGORY = '0'; // 123 отображается вьіше... "!NO_NAME_CATEGORY" : дело не в сортировке а в представлении обьекта в js даже в случае алфавитного порядка добавления, поля с числовыми ключами оказываются раньше остальных
